import { call, put, takeLatest } from "redux-saga/effects";

import { doctorsApi } from "../../services/api/doctors.api";
import { Specialty } from "../../types/specialty.definition";
import {
  getSpecialtiesFailure,
  getSpecialtiesRequest,
  getSpecialtiesSuccess,
} from "../reducers/specialtiesSlice";

export function* getSpecialtiesSaga() {
  try {
    const specialties: Specialty[] = yield call(doctorsApi.getAllSpecialties);
    yield put(getSpecialtiesSuccess(specialties));
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : "Failed to fetch specialties";
    yield put(getSpecialtiesFailure(errorMessage));
  }
}

export function* watchGetSpecialties() {
  yield takeLatest(getSpecialtiesRequest.type, getSpecialtiesSaga);
}
